// extracted by mini-css-extract-plugin
export default {"root":"MobileDrawer_root__TkbOZ","content":"MobileDrawer_content__CHs3J"};